import { locationIdFormat } from "@redotech/redo-inventory-id";
import { productIdFormat } from "@redotech/redo-product-id";
import { processingSessionIdFormat } from "@redotech/redo-return-id";
import * as z from "zod";
import { ProcessingSessionItem } from "./processing-session";

export const addUndeclaredItemToProcessingSession = {
  name: "addUndeclaredItemToProcessingSession" as const,
  input: z.object({
    sessionId: processingSessionIdFormat.schema,
    locationId: locationIdFormat.schema,
    productId: productIdFormat.schema.optional(),
  }),
  output: z.object({ sessionItem: ProcessingSessionItem }),
};
